import axiosInstance from "./axiosInstance";
import { PlannerViewResponse } from "../types/plannerView";

export const getPlannerView = async (
  plantId: string

): Promise<PlannerViewResponse> => {
  const response = await axiosInstance.get<PlannerViewResponse>(
    "/api/input-view",
    {
      params: { plantId },
    }
  );

const rowsWithId = response.data?.map((row, index) => ({
    ...row,
    inputId: `workflowId_${index}`,
  }));

  return rowsWithId;
};
